import { render, staticRenderFns } from "./RoleTab.vue?vue&type=template&id=cebbb016&scoped=true"
import script from "./RoleTab.vue?vue&type=script&lang=js"
export * from "./RoleTab.vue?vue&type=script&lang=js"
import style0 from "./RoleTab.vue?vue&type=style&index=0&id=cebbb016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebbb016",
  null
  
)

export default component.exports